"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDate = exports.mmyyyy = exports.mmYYYY = exports.hhmm = exports.getDateIsValid = exports.formatDate = exports.ddmmyyyy = exports.ddMM = exports.datesAreOnSameDay = exports.WEEKDAYS_SHORT = exports.WEEKDAYS_LONG = exports.MONTHS_SHORT = exports.MONTHS = exports.MM = exports.DDMMYYYY = void 0;
const MONTHS = exports.MONTHS = ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'];
const MONTHS_SHORT = exports.MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'];
const WEEKDAYS_LONG = exports.WEEKDAYS_LONG = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'];
const WEEKDAYS_SHORT = exports.WEEKDAYS_SHORT = ['S', 'M', 'T', 'O', 'T', 'F', 'L'];
const parseDate = (date, format, locale, minDate, maxDate) => {
  const format1 = (date.length === 10 || date.length === 8) && date.includes('.');
  const format2 = (date.length === 6 || date.length === 8) && !date.includes('.');
  if (!date || !format1 && !format2) {
    return;
  }
  let arr;
  if (format1) {
    arr = date.split('.');
  }
  if (format2) {
    arr = [date.substring(2, 0)];
    arr.push(date.substring(2, 4));
    arr.push(date.substring(4, 8));
  }
  if (!arr) {
    return;
  }
  const day = parseInt(arr[0]);
  const month = parseInt(arr[1]);
  const year = parseInt(arr[2]);
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return;
  }
  let newYear = year;
  if (newYear < 40) newYear = parseInt(String(2000 + year));
  const rest = new Date(newYear, month - 1, day, 12);
  if (!getDateIsValid(rest, minDate, maxDate)) {
    return;
  }
  return rest;
};
exports.parseDate = parseDate;
const formatDate = (date, format, locale) => {
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  return new Intl.DateTimeFormat(['no-NO', 'nb-NO', 'nn-NO', 'de-DE'], options).format(new Date(date));
};
exports.formatDate = formatDate;
const getDateIsValid = (date, minDate, maxDate) => {
  if (!date) return false;
  const min = minDate ? new Date(minDate) : null;
  const max = maxDate ? new Date(maxDate) : null;
  date = new Date(date);
  date.setHours(12);
  if (min) min.setHours(0);
  if (max) max.setHours(24);
  if (!(min || max)) return true;
  return (!min || min && date >= min) && (!max || max && date <= max);
};
exports.getDateIsValid = getDateIsValid;
const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
exports.datesAreOnSameDay = datesAreOnSameDay;
const ddmmyyyy = exports.ddmmyyyy = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
};
const ddMM = exports.ddMM = {
  day: 'numeric',
  month: 'long'
};
const MM = exports.MM = {
  month: 'short'
};
const mmYYYY = exports.mmYYYY = {
  month: 'long',
  year: 'numeric'
};
const mmyyyy = exports.mmyyyy = {
  month: '2-digit',
  year: 'numeric'
};
const hhmm = exports.hhmm = {
  hour: '2-digit',
  minute: '2-digit'
};
const DDMMYYYY = exports.DDMMYYYY = {
  day: '2-digit',
  month: 'long',
  year: 'numeric'
};